import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";
import { pricelistCaseFilesReadyBundleSchema } from "./shapes";

export const preparePricelistCaseFilesReadyReminderStep = defineStepConfig({
  type: "prepare_pricelist_case_files_ready_reminder",
  name: "Prepare Pricelist Case Files-Ready Reminder",
  description:
    "Render the files-ready / upload-timing digest for one pricelist-case " +
    "assignee and resolve their channels. Feeds Send Announcement " +
    "(input-driven mode). Distinct from due-follow-up chase.",
  category: "Data Transform",
  libraryModule: "ItemMaster",

  inputSchema: z.object({
    recipientReminder: pricelistCaseFilesReadyBundleSchema.describe(
      "One assignee's files-ready reminder bundle. Connect the 'reminders' " +
        "array output of Query Due Pricelist Case Files Ready here.",
    ),
  }),

  outputSchema: z.object({
    recipientUserIds: z.array(z.string().uuid()),
    title: z.string(),
    body: z.string(),
    channels: z.array(z.enum(["in_app", "email"])),
  }),

  configSchema: z.object({
    fallbackChannels: z
      .array(z.enum(["in_app", "email"]))
      .min(1)
      .default(["in_app"])
      .describe(
        "Channels used when the recipient has not saved a pricelist-case " +
          "reminder channel preference.",
      ),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "30 seconds",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "5 seconds",
    },
  },
});
